import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { updateUserPreference } from "../../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";
import { showErrorSnackbar } from "../snackBar/snakbar";
import { useThemes } from "../Theme/theme";
import { fetchUserPreference } from "../../redux/reducers/UserPreference";
import { createUserPreference } from "../../graphql";
import { useMediaQuery } from "@mui/material";

export const GuidedNav = forwardRef(({ props }, ref) => {
  const { theme } = useThemes();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(null);
  const [firstNavigationCompleted, setFirstNavigationCompleted] = useState(
    localStorage.getItem("firstNavigationCompleted")
  );
  let driverInstance;
  const driverInstanceRef = useRef(null);
  const savedStep = localStorage.getItem("tutorialStep");

  // const {modalz} =  props
  const smallDevice = useMediaQuery(theme.breakpoints.down("md"))
  const smallDeviceMobile = useMediaQuery(theme.breakpoints.down("sm"))

  // console.log(modalz,"=====>modalzzz")

  const navFn = (res) => {

    console.log(res,"===>resss")
    if (res?.className?.includes("AppSettings")) {
      navigate("/?active=BalanceSheet");
      setTimeout(() => {
        driverInstanceRef.current?.moveNext();
      }, 2000);
    } else {
      driverInstanceRef.current?.moveNext();
    }
  };
  let stopGuidedNavigation;
  const handleKeyDown = async (e, currentStep) => {
    if (
      document.getElementsByClassName("Class-poper").length !== 0 ||
      document.getElementsByClassName("custom-popover-class").length !== 0
    ) {
      if (
        localStorage.getItem("tutorialCompleted") !== true &&
        (e.key == "Enter" || e.keyCode === 32)
      ) {
        e.preventDefault();
      }
      if (e.key == "Tab" && e.shiftKey) {
        if (driverInstanceRef.current.hasPreviousStep() == undefined) {
          return;
        }
        driverInstanceRef.current.movePrevious();
      } else if (e.key == "Tab") {
        // console.log(currentStep, "////");
        // localStorage.setItem(
        //   "tutorialStep",
        //   Number(currentStep) + 1 == 8 ? 0 : Number(currentStep) + 1
        // );
        e.preventDefault();
        navFn(e);
      }
    }
    if (e.keyCode === 32 && e.ctrlKey && e.shiftKey) {
      localStorage.setItem("tutorialCompleted", "true");
      localStorage.setItem("tutorialStep", 0);
      driverInstance?.destroy();
    }
  };

  const startGuidedNavigation = () => {
    localStorage.setItem("tutorialCompleted", "false");
    localStorage.setItem("startedNavigation",true)
    // localStorage.setItem("tutorialStep", "0");
    
    

    if (driverInstanceRef.current) {
      driverInstanceRef.current.destroy();
    }

    const steps = smallDevice
      ? [
             {
            element: ".more1",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: "Click here and select company to switch between multiple companies or financial years.",
            },
          },
          {
            element: ".BalanceSheet",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: `<i style=color:red>Easily</i> create any Ledger Accounts, Groups, Vouchers & View Balance Sheet`,
            },
          },
          {
            element: ".G",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: smallDeviceMobile ? 'Click and open "G" to Create sub Groups' :'Click on "G" to Create sub Groups',
            },
          },
          {
            element: ".L",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: smallDeviceMobile ? `Click and open "L" to Create new Ledger A/C's` : `Click on "L" to Create new Ledger A/C's`,
            },
          },
          {
            element: ".V",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: smallDeviceMobile ? 'Click and open "V" to Create new Vouchers' :'Click on "V" to Create new Vouchers',
            },
          },
        ]
      : [  
        {
            element: ".step-1",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: "Click here to complete your Company setup",
            },
          }, 
           {
            element: ".SwitchComp",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: "Switch between Multiple, Companies or Financial Years",
            },
          },
            {
            element: ".G",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: 'Click on "G" to Create sub Groups',
            },
          },
           {
            element: ".L",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: `Click on "L" to Create new Ledger A/C's`,
            },
          },
           {
            element: ".V",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: 'Click on "V" to Create new Vouchers',
            },
          }, 
          {
            element: ".BalanceSheet",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: `<i style=color:red>Easily</i> create any Ledger Accounts, Groups, Vouchers & View Balance Sheet`,
            },
          }, 
           {
            element: ".quickLink",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: "Use quick links or Search to access any page.",
            },
          },
            {
            element: ".myPostingDate",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: "Sets default posting date for all transactions",
            },
          },  
          {
            element: ".supportPage",
            popover: {
              className: theme?.palette?.TmId.id.toString().includes("9")
                ? "custom-popover-class"
                : "",
              title: 'Report issues or share your suggestions here to help us improve the app.',
            },
          },
          // {
          //   element: ".AppSettings",
          //   popover: {
          //     className: theme?.palette?.TmId.id.toString().includes("9")
          //       ? "custom-popover-class"
          //       : "",
          //     title: "Click here to customize the application settings",
          //   },
          // },   
        ];
  

    const handleClick = (event) => {
      event.stopPropagation();
      event.preventDefault();
    };

    let close = JSON.parse(localStorage.getItem("FirstTutorial"));

    driverInstance = new driver({
      popoverClass: theme?.palette?.TmId.id.toString().includes("9")
        ? "custom-popover-class"
        : "Class-poper",
      overlayOpacity: 0.5,
      // allowClose: close ? true : false,
      allowClose: false,
      allowKeyboardControl: false,
      doneBtnText: "Finish",
      showProgress: true,
      // stageRadius: 50, 
      stageBorder:'solid 1px yellow',// Set highlight border radius to 50px
      steps,
      onHighlighted: (element) => {
        element?.addEventListener("click", handleClick);
 
        console.log(element.className,"!!!element")
        console.log("Element found:", element, "Element visible:", element?.offsetParent !== null);
        
        if (element.className.includes("step-1")) {
          element.style.transform = "translateX(8px)";
          element.style.transition = "transform 0.1s ease"; // optional smooth motion
        }
        
        // Special handling for supportPagerr element
        if (element.className.includes("supportPagerr")) {
          console.log("Support page element highlighted");
          // Ensure the element is visible and accessible
          if (element.offsetParent === null) {
            console.warn("Support page element is not visible!");
          }
        }
        
        if (
          !window.location.href.includes("active=BalanceSheet") &&
          !window.location.href.includes("active=Business_Overview")
        ) {
          navigate("/?active=BalanceSheet");
        }
        if (
          !window.location.href.includes("active=BalanceSheet") &&
          !window.location.href.includes("active=Business_Overview")
        ) {
          navigate("/?active=BalanceSheet");
        }
      },
      onDeselected: (element) => {
        element?.removeEventListener("click", handleClick);
      },
      onDestroyed: () => {
        if(localStorage.getItem("firstTimeUser")){
          localStorage.setItem("screenRotate",true)
        }
        localStorage.setItem("tutorialCompleted", "true");
        localStorage.removeItem("startedNavigation");
        localStorage.setItem("tutorialStep", "0");
        localStorage.removeItem("firstTimeUser");
        navigate("/?active=Business_Overview");
        if (close === null) {
          localStorage.setItem("FirstTutorial", true);
        }
        // const currentStepIndex = steps.findIndex((step) =>
        //   e.className.includes(step.element.replace(".", ""))
        // );
        window.removeEventListener("keydown", handleKeyDown);
      },
      onNextClick: (e) => {
        console.log(e,"====>e")
        const currentStepIndex = steps.findIndex((step) =>
          e.className.includes(step.element.replace(".", ""))
        );
        setCurrentStep(Number(currentStepIndex) + 1);
        localStorage.setItem(
          "tutorialStep",
          Number(currentStepIndex) + 1 == 9 ? 0 : Number(currentStepIndex) + 1
        );
        navFn(e);
      },

      onPreviousClick: (e) => {
        const currentStepIndex = steps.findIndex((step) =>
          e.className.includes(step.element.replace(".", ""))
        );
        setCurrentStep(Number(currentStepIndex) + 1);
        localStorage.setItem(
          "tutorialStep",
          Number(currentStepIndex) - 1 == -1 ? 0 : Number(currentStepIndex) + 1
        );
        navFn(e);
      },
      onPopoverRender: (popover, { config, state }) => {
        popover.nextButton.textContent = state.activeStep.element === ".supportPage" ? "Finish" :  "Next";
        popover.previousButton.textContent = "Previous";
        popover.wrapper.style.border = "2.5px solidrgb(130, 88, 88)";
        popover.arrow.style.border = "10px solid transparent";
        popover.arrow.style.borderLeftColor = "#8c88c";
        popover.nextButton.style.background = `${theme.palette.primary.main}`;
        popover.nextButton.style.color = "white";
        popover.nextButton.style.fontSize = "15px";
        popover.previousButton.style.fontSize = "15px";
        popover.nextButton.style.borderRadius = "5px";
        popover.nextButton.style.textShadow = "none";
        popover.nextButton.style.lineHeight = "0";
        navigate("/?active=BalanceSheet");

        const closeButton = document.createElement("div");
        closeButton.innerText = "x";
        closeButton.className = "close-button";
        closeButton.onclick = () => {
          driverInstance?.destroy();
          localStorage.setItem("tutorialCompleted", "true");
          localStorage.setItem("tutorialStep", 0);
        };
        if (window.location.href.includes("login")) {
          driverInstance?.destroy();
        }
        if (
          localStorage.getItem("tutorialCompleted") == undefined ||
          localStorage.getItem("tutorialCompleted") == null
        ) {
          driverInstance?.destroy();
        }
        if (window.location.href.includes("login")) {
          driverInstance?.destroy();
        }
        if (
          localStorage.getItem("tutorialCompleted") == undefined ||
          localStorage.getItem("tutorialCompleted") == null
        ) {
          driverInstance?.destroy();
        }

        if (
          document.getElementsByClassName("Class-poper").length !== 0 ||
          document.getElementsByClassName("custom-popover-class").length !== 0
        ) {
          window.addEventListener("keydown", handleKeyDown);
        } else {
          window.removeEventListener("keydown", handleKeyDown);
        }
        if (close !== "null" && close !== null) {
          popover.wrapper.appendChild(closeButton);
        }
      },
    });
    driverInstanceRef.current = driverInstance;
    let Status = localStorage.getItem("tutorialCompleted");
    if (Status == "false") {
      if (savedStep >= 0) {
        driverInstance.drive(parseInt(savedStep, 10));
      } else {
        driverInstance.drive();
      }
    }
  };

  const destroyTutorial = () => {
    if (driverInstanceRef.current) {
      driverInstanceRef.current.destroy();
      driverInstanceRef.current = null;
    }
    localStorage.setItem("tutorialCompleted", "true");
    localStorage.setItem("tutorialStep", "0");
    window.removeEventListener("keydown", handleKeyDown);
  };

  useImperativeHandle(ref, () => ({
    startGuidedNavigation,
    destroyTutorial,
  }));
  let selector = useSelector((state) => state.loginActions.loginStatus);

  if (window.location.href.includes("login")) {
    driverInstance?.destroy();
  }
  useEffect(() => {
    if (!selector) {
      destroyTutorial();
    }
  }, [selector]);

  useEffect(() => {
    if (savedStep >= 0 && props !== "close") {
      startGuidedNavigation();
    }
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("firstTimeUser") &&
      firstNavigationCompleted === "true"
    ) {
      startGuidedNavigation();
    }
  }, [firstNavigationCompleted]);


  const handleBeforeUnload = (event) => {
    localStorage.setItem("tutorialStep", "0");
  };

  useEffect(() => {
  const tutorialCompleted = localStorage.getItem("startedNavigation");
  if (tutorialCompleted === "true") {
    startGuidedNavigation();
  }
}, []);

  // Listen for localStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      const newValue = localStorage.getItem("firstNavigationCompleted");
      setFirstNavigationCompleted(newValue);
    };

    // Listen for storage events (when localStorage changes from other tabs/windows)
    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically for changes within the same tab
    const interval = setInterval(() => {
      const currentValue = localStorage.getItem("firstNavigationCompleted");
      if (currentValue !== firstNavigationCompleted) {
        setFirstNavigationCompleted(currentValue);
      }
    }, 100);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [firstNavigationCompleted]);



  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return null;
});
